<template lang="html">
  <div class="pl-subheading vh-100 overflow-y-scroll ph5 pv3">
    <pl-button
      class="pl-primary"
      style="margin: 0 0 10px 0"
      @click.native="$router.go(-1)"
      >GO BACK</pl-button
    >

    <!-- Subjects -->
    <div class="dev-border pa2">
      <span class="titles" @click="toggleEditingArea('subjects')"
        >Subjects</span
      >
      <div v-if="currently_editing.includes('subjects')">
        <span class="ml1 pl-color-ruby"
          >(a position of 0 will exclude it from the universe home page)</span
        >
        <ul>
          <li v-for="subject in subjects" :key="subject.name">
            <span class="pl-title">{{ subject.name }}</span>
            <pl-button
              @click.native="editSubjectName(subject.id)"
              class="pl-small pl-icon"
            >
              <i class="fas fa-edit"></i>
            </pl-button>
            <pl-button
              @click.native="deleteSubject(subject.id)"
              class="pl-small pl-icon"
            >
              <i class="fas fa-remove"></i>
            </pl-button>
            <br />
            <span>Position:</span>
            <select
              @change="editSubjectPosition(subject.id, $event)"
              v-model="subject.position"
            >
              <option
                :value="index"
                :key="subject.name + index"
                v-for="(position, index) in subjects.length + 1"
              >
                {{ index }}
              </option>
            </select>

            <!-- Edit collections that belong to this subject -->
            <br />
            <pl-button
              v-if="subject_to_edit_collections !== subject.name"
              @click.native="getSubjectCategories(subject)"
            >
              Edit Collections
            </pl-button>
            <section v-else>
              Contains following collections:
              <div
                v-for="(category, index) in categories_with_subjects"
                :key="subject.name + category.name"
                class="flex cat-container"
              >
                <select
                  v-bind:style="{
                    visibility: subjectCategoryIsSelected(subject, category)
                      ? 'visible'
                      : 'hidden',
                  }"
                  v-model="category.subject_position"
                  class="cat-position"
                >
                  <option
                    :value="index"
                    :key="category.name + index"
                    v-for="(
                      position, index
                    ) in categories_with_subjects.length + 1"
                  >
                    {{ index }}
                  </option>
                </select>
                <pl-checkbox
                  ref="'checkbox' + index"
                  v-model="subject.collections"
                  :value="category"
                />
                <span>{{ category.name }}</span>
              </div>
              <pl-button
                @click.native="saveSubjectCollections(subject.id)"
                class="pl-primary"
                >Save</pl-button
              >
              <pl-button
                @click.native="subject_to_edit_collections = ''"
                class="pl-secondary"
                >Close</pl-button
              >
            </section>

            <hr />
          </li>
        </ul>
        <div class="">
          <span class="titles">Create New Subject</span>
          <pl-input v-model="new_subject" />
          <pl-button
            :disabled="!new_subject"
            class="pl-primary"
            @click.native="createNewSubject"
          >
            Add new
          </pl-button>
        </div>
      </div>
    </div>

    <!-- Grades -->
    <div class="dev-border pa2">
      <span class="titles" @click="toggleEditingArea('grades')">Grades</span>
      <div v-if="currently_editing.includes('grades')">
        <ul>
          <li v-for="grade in grades" :key="grade.id">
            {{ grade.grade }}
            <pl-button
              @click.native="editGrade(grade)"
              class="pl-small pl-icon"
            >
              <i class="fas fa-edit"></i>
            </pl-button>
            <pl-button
              @click.native="deleteGradeLevel(grade)"
              class="pl-small pl-icon"
            >
              <i class="fa fa-times delete-answer"></i>
            </pl-button>
          </li>
        </ul>
        <div class="">
          <span class="titles">Create New Grade</span>
          <pl-input v-model="new_grade" />
          <pl-button
            :disabled="!new_grade"
            class="pl-primary"
            @click.native="createNewGrade"
          >
            Add new
          </pl-button>
        </div>
      </div>
    </div>

        <!-- Skills -->
    <div class="dev-border pa2">
      <span class="titles" @click="toggleEditingArea('skills')">Skills</span>
      <div v-if="currently_editing.includes('skills')">
        <ul>
          <li v-for="skill in skills" :key="skill.id">
            {{ skill.name }}
            <pl-button
              @click.native="editSkill(skill)"
              class="pl-small pl-icon"
            >
              <i class="fas fa-edit"></i>
            </pl-button>
            <pl-button
              @click.native="deleteSkill(skill)"
              class="pl-small pl-icon"
            >
              <i class="fa fa-times delete-answer"></i>
            </pl-button>
          </li>
        </ul>
        <div class="">
          <span class="titles">Create New Skill</span>
          <pl-input v-model="new_skill" />
          <pl-button
            :disabled="!new_skill"
            class="pl-primary"
            @click.native="createNewSkill"
          >
            Add new
          </pl-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        subject_to_edit_collections: '',
        new_grade: '',
        new_subject: '',
        new_category: '',
        new_skill: '',
        grades: [],
        subjects: [],
        skills: [],
        currently_editing: [],
        categories_with_subjects: [],
      };
    },
    computed: {},
    methods: {
      toggleEditingArea(area) {
        this.currently_editing.includes(area)
          ? this.currently_editing.splice(
              this.currently_editing.indexOf(area),
              1
            )
          : this.currently_editing.push(area);
      },
      // Grades Actions
      editGrade(grade_level) {
        const new_value = prompt('What is the new grade name?');
        if (new_value) {
          grade_level.grade = new_value;

          adminServices
            .editGradeLevel(grade_level.id, grade_level)
            .then(() => {
              this.loadGrades();
            })
            .catch(console.log);
        }
      },
      createNewGrade() {
        if (this.new_grade === '') {
          return null;
        }
        adminServices
          .createNewGrade(this.new_grade)
          .then(() => {
            this.new_grade = null;
            this.loadGrades();
          })
          .catch(console.log);
      },
      deleteGradeLevel(grade_level) {
        const has_confirmed = confirm(
          'Are you sure you would like to delete this grade level? All Roundtables, Collections and Users in the Universe will be dissasociated with this grade level'
        );
        if (has_confirmed) {
          adminServices
            .deleteGradeLevel(grade_level.id)
            .then(() => {
              this.loadGrades();
            })
            .catch(console.log);
        }
      },
      editSkill(skill) {
        const new_value = prompt('What is the new skill name?');
        if (new_value) {
          skill.name = new_value;
          adminServices
            .editSkill(skill.id, skill)
            .then(() => {
              this.loadSkills();
            })
            .catch(console.log);
        }
      },
      createNewSkill() {
        if (this.new_skill === '') {
          return null;
        }
        adminServices
          .createNewSkill(this.new_skill)
          .then(() => {
            this.new_skill = null;
            this.loadSkills();
          })
          .catch(console.log);
      },
      deleteSkill(skill) {
        const has_confirmed = confirm(
          `Are you sure you would like to delete this skill?\nAll Roundtables in the Universe will be dissasociated with this skill`
        );
        if (has_confirmed) {
          adminServices
            .deleteSkill(skill.id)
            .then(() => {
              this.loadSkills();
            })
            .catch(console.log);
        }
      },
      saveSubjectCollections(subject_id) {
        const subject = this.subjects.find((s) => s.id === subject_id);

        const categoriesToUpdate = this.categories_with_subjects.filter((x) =>
          subject.collections.map((y) => y.id).includes(x.id)
        );

        if (subject && Array.isArray(subject.collections)) {
          adminServices
            .editSubject(subject_id, { collections: categoriesToUpdate })
            .then(() => {
              EventBus.$emit('toast-msg', 'Changes saved!');
            })
            .catch(console.error);
        }
      },
      // Subject actions
      editSubjectName(subject_id) {
        const new_name = prompt('What is the new subject name?');
        if (new_name) {
          adminServices.editSubject(subject_id, { name: new_name }).then(() => {
            const index = this.subjects.findIndex((el) => el.id === subject_id);
            this.subjects[index].name = new_name;
          });
        }
      },
      editSubjectPosition(subject_id, event) {
        adminServices
          .editSubject(subject_id, { position: event.target.value })
          .then(() => {
            EventBus.$emit('toast-msg', 'Changes saved!');
          })
          .catch(console.error);
      },
      createNewSubject() {
        if (this.new_subject === '') {
          return null;
        }
        adminServices.createNewSubject(this.new_subject).then((response) => {
          this.new_subject = '';
          this.subjects.push(response.data);
        });
      },
      deleteSubject(subject_id) {
        const has_confirmed = confirm(
          'Are you sure you would like to delete this subject Name? All Roundtables In the universe will be dissasociated with this subject'
        );
        if (has_confirmed) {
          adminServices
            .deleteSubject(subject_id)
            .then(() => {
              const index = this.subjects.findIndex(
                (el) => el.id === subject_id
              );
              this.subjects.splice(index, 1);
            })
            .catch(console.log);
        }
      },
      getSubjectCategories(subject) {
        const subjectId = subject.id;

        this.$store.dispatch('getAllSubjects').then((results) => {
          this.subjects = results;

          adminServices
            .getSubjectWithCategoriesPositions(subjectId)
            .then((res) => {
              const subjectWithCategoriesPositions = res.data;

              this.categories_with_subjects = subjectWithCategoriesPositions;
              this.subject_to_edit_collections = subject.name;
            });
        });
      },
      loadSubjects() {
        return this.$store.dispatch('getAllSubjects').then((results) => {
          this.subjects = results;
        });
      },
      loadGrades() {
        return this.$store.dispatch('getAllGradeLevels').then((results) => {
          this.grades = results;
        });
      },
      loadSkills() {
        return this.$store.dispatch('getAllSkills').then((results) => {
          this.skills = results;
        });
      },
      loadPage() {
        this.loadSubjects();
        this.loadGrades();
        this.loadSkills();
      },
      subjectCategoryIsSelected(sub, category) {
        const subject = this.subjects.find((s) => s.id === sub.id);

        if (subject && !Array.isArray(subject.collections)) {
          subject.collections = [];
        } else {
          const result = subject.collections.find((x) => x.id === category.id);

          return result;
        }
      },
    },
    created() {
      this.loadPage();
    },
  };
</script>

<style scoped lang="stylus">
  .titles {
    margin: 0 5px;
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
  }

  .cat-position {
    margin-left: -13px;
    margin-right: 10px;
  }

  .cat-container {
    padding-top: 18px;

    select {
      position: relative;
      bottom: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// adminUniverseSettings.vue?7c621036